import { forwardRef } from 'react';

interface HiddenFileInputProps {
  onFilesSelected: (files: File[]) => void;
  acceptPdf?: boolean;
}

export const HiddenFileInput = forwardRef<HTMLInputElement, HiddenFileInputProps>(
  function HiddenFileInput({ onFilesSelected, acceptPdf = false }, ref) {
    const acceptValue = acceptPdf ? 'image/*,.pdf' : 'image/*';
    return (
      <input
        ref={ref}
        type="file"
        accept={acceptValue}
        multiple
        onChange={(e) => {
          const selectedFiles = Array.from(e.target.files || []);
          void onFilesSelected(selectedFiles);
          if (e.target) {
            e.target.value = '';
          }
        }}
        style={{ display: 'none' }}
      />
    );
  },
);
